
import React from 'react';
import logoImage from '../assets/logo.png';

export default function Logo({ className = "", ...props }: React.HTMLAttributes<HTMLImageElement>) {
  return (
    <img
      src={logoImage}
      alt="Maturity Compass Logo"
      className={className}
      {...props}
    />
  );
}
